/* eslint-disable react/prop-types */
import "./Technology.css";

export default function Technology(props) {
  return <div className="technology">{props.name}</div>;
}
